import { NgOptimizedImage } from '@angular/common'
import { ChangeDetectionStrategy, Component, input } from '@angular/core'

@Component({
	selector: 'mos-currency-icon',
	imports: [NgOptimizedImage],
	templateUrl: './currency-icon.component.html',
	styleUrl: './currency-icon.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CurrencyIconComponent {
	currency = input.required<'key' | 'ticket'>()
}
